import { motion } from "framer-motion";
import { ArrowRightIcon } from "../../../../components/icons";
import { pressable } from "../../../../components/motion";
import { cn } from "../../../../utils/classnames";

// Shared shape: fixed height so the label and icon sit on one centred line, and the
// same small corner radius as the form inputs (Bootstrap `rounded` = 0.375rem).
// Bootstrap's reboot sets `button { border-radius: 0; font-size: inherit }` outside
// Tailwind's layers, so radius and size need the trailing `!` to win.
const BUTTON_BASE =
  "tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:h-12 tw:px-8 tw:rounded-[0.375rem]! tw:text-[15px]! tw:font-semibold tw:leading-none tw:whitespace-nowrap tw:transition-colors tw:duration-200 tw:cursor-pointer tw:disabled:cursor-not-allowed tw:disabled:opacity-50";

const BUTTON_VARIANTS = {
  primary: "tw:bg-[#DBBE78] tw:border tw:border-[#DBBE78] tw:text-white tw:hover:bg-[#C9A95E] tw:hover:border-[#C9A95E]",
  outline: "tw:bg-white tw:border tw:border-[#D9D9D9] tw:text-[#282828] tw:hover:border-[#282828]",
  dark: "tw:bg-[#282828] tw:border tw:border-[#282828] tw:text-white tw:hover:bg-black",
};

/**
 * Rounded call-to-action used across the register flow.
 * `icon` sits after the label (or before it with `iconFirst`).
 */
export const RegisterButton = ({
  variant = "primary",
  icon,
  iconFirst = false,
  disabled = false,
  className,
  children,
  ...buttonProps
}) => (
  <motion.button
    type="button"
    className={cn(BUTTON_BASE, BUTTON_VARIANTS[variant], className)}
    disabled={disabled}
    // No hover/press feedback on a button that can't be clicked.
    whileHover={disabled ? undefined : pressable.hover}
    whileTap={disabled ? undefined : pressable.tap}
    {...buttonProps}
  >
    {iconFirst && icon}
    <span>{children}</span>
    {!iconFirst && icon}
  </motion.button>
);

export const NextArrow = ({ color = "white" }) => <ArrowRightIcon color={color} size={18} />;

// Same arrow, flipped to point back.
export const BackArrow = ({ color = "#282828" }) => (
  <ArrowRightIcon color={color} size={18} style={{ transform: "rotate(180deg)" }} />
);
